import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=03b1a4ed"
import script from "./tags.vue?vue&type=script&lang=js"
export * from "./tags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03b1a4ed')) {
      api.createRecord('03b1a4ed', component.options)
    } else {
      api.reload('03b1a4ed', component.options)
    }
    module.hot.accept("./tags.vue?vue&type=template&id=03b1a4ed", function () {
      api.rerender('03b1a4ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/index/tags.vue"
export default component.exports